<template>
  <section class="p-configmonitor">
    <section class="c-visible-pc" v-if="$store.state.isPc">
      <section class="monitor-wrap">
        <section class="c-mt-84 monitor-title">
          <p class="c-fs-32 c-mb c-fw-b c-c-text-color-dark">网络配置管理系统</p>
          <p class="c-fs-16 c-mt-36 c-lh-38 c-ta-j">MonitorWay 网络配置管理系统，标准化并保护您的网络。</p>
          <p class="c-fs-16 c-mb-56 c-lh-38 c-ta-j">开始监控网络之前，请先进行配置！可靠且安全的网络源自细心规划、执行和监控的网络配置和更改管理。MonitorWay 网络配置管理系统可以为 Cisco®、Juniper®、HP®、
            Dell®、Brocade®、F5®、Aruba®、Rukus® 、华为、锐捷、H3C 等国内外主流厂商提供的路由器、交换机和其他网络设备管理配置、定时巡检等功能，从而节省时间并提高网络可靠性及安全性。</p>
          <img src="../../assets/monitor/config.jpg" class="c-cs-p" preview="monitor-config"/>
        </section>
        <section>
          <div class="c-d-f c-ai-c c-mt-84">
            <img src="../../assets/index/icon.png">
            <span class="c-ml-12 c-fs-24">MonitorWay 网络配置管理系统概览</span>
          </div>
          <div class="c-bc-white c-fs-14 c-c-text-grey c-lh-36 c-mt-40 c-pt-56 c-pl-92 c-pb-128 c-p-r">
            <ul>
              <li>使用标准化设备配置和自动化部署减少配置错误。</li>
              <li>使用更改监控、警报、配置备份和回滚提高网络可靠性。</li>
              <li>使用多级密码执行，借助角色和权限二级密码的开关设置，提高执行的安全控制。</li>
              <li>内置支持100+国内外主流厂商设备品牌的配置命令集。</li>
            </ul>
            <img src="../../assets/monitor/config-pic.png" class="c-pr-40 pic">
          </div>
        </section>
        <section class="c-pb-164 features">
          <div class="c-d-f c-ai-c c-mt-80">
            <img src="../../assets/index/icon.png">
            <span class="c-ml-12 c-fs-24">功能介绍</span>
          </div>
          <div class="c-d-f c-jc-sb c-fw-w c-mt-40 features-wrap">
            <div class="c-d-f c-jc-sb c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/config1.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">批量备份和恢复配置</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">可以手动或者设置定时任务的方式，批量对指定的设备进行配置备份的工作，也可以批量进行恢复配置的工作</p>
              </div>
            </div>
            <div class="c-d-f c-jc-sb c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/config2.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">批量配置下发</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">可以通过自定义脚本的方式，对选择的批量对象，进行配置下发的工作，大大提升的运维变更的效率</p>
              </div>
            </div>
            <div class="c-d-f c-jc-sb c-ai-fs c-bc-white features-item features-special">
              <img src="../../assets/monitor/config3.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">定时巡检任务</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">针对 IT 基础环境中大批量的硬件设备而言，定期获取设备指定运行状态是一项工作量极大的工作，
                  定时巡检任务可以定义自定义的指令和定期执行获取相应数据，并输出成对应报表，大大减少了巡检的工作
                </p>
              </div>
            </div>
            <div class="c-d-f c-jc-sb c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/config4.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">设备配置对比</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">可以手动进行设备配置的对比，比将对比的结果差异化的展现出来，也可以定期生成配置变更报告，快速定位变更配置</p>
              </div>
            </div>
            <div class="c-d-f c-jc-sb c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/internet5.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">二级密码保护</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">使用多级密码执行，从而防止发生错误。通过控制谁能够对设备和配置进行更改，并且要求使用二级密码进行更改，提高执行的安全控制</p>
              </div>
            </div>
          </div>
        </section>
      </section>
    </section>
    <section class="c-visible-mobile" v-if="!$store.state.isPc">
      <section class="cm-width monitor-wrap-mobile">
        <section class="c-mt-40 monitor-title">
          <p class="c-fs-19 c-fw-b c-c-text-color-dark">网络配置管理系统</p>
          <p class="c-fs-12 c-mt-16 c-lh-22 c-ta-j">MonitorWay 网络配置管理系统，标准化并保护您的网络。</p>
          <p class="c-fs-12 c-mb-24 c-lh-22 c-ta-j">开始监控网络之前，请先进行配置！可靠且安全的网络源自细心规划、执行和监控的网络配置和更改管理。MonitorWay 网络配置管理系统可以为 Cisco®、Juniper®、HP®、Dell®、Brocade®、F5®、Aruba®、Rukus® 、
            华为、锐捷、H3C 等国内外主流厂商提供的路由器、交换机和其他网络设备管理配置、定时巡检等功能，从而节省时间并提高网络可靠性及安全性。</p>
          <img src="../../assets/monitor/config.jpg" preview="monitor-config1"/>
        </section>
        <section>
          <div class="c-d-f c-ai-c c-mt-40">
            <img class="c-icon-mobile" src="../../assets/index/icon.png">
            <span class="c-ml-8 c-fs-16">MonitorWay 网络配置管理系统</span>
          </div>
          <div class="c-bc-white c-fs-13 c-c-text-grey c-lh-28 c-mt-24 c-ptb-20 c-pl-36 c-pr-16 c-boxshadow">
            <ul>
              <li>使用标准化设备配置和自动化部署减少配置错误。</li>
              <li>使用更改监控、警报、配置备份和回滚提高网络可靠性。</li>
              <li>使用多级密码执行，借助角色和权限二级密码的开关设置，提高执行的安全控制。</li>
              <li>内置支持100+国内外主流厂商设备品牌的配置命令集。</li>
            </ul>
          </div>
        </section>
        <section class="features">
          <div class="c-d-f c-ai-c c-mt-40">
            <img class="c-icon-mobile" src="../../assets/index/icon.png">
            <span class="c-ml-8 c-fs-16">功能介绍</span>
          </div>
          <div class="c-mt-24 features-wrap">
            <div class="c-mb-8 features-item">
              <div class="c-bc-white c-d-f c-pe-none">
                <img src="../../assets/monitor/config1.png">
                <div class="c-ml-24">
                  <p class="c-fs-15 c-c-text-blue c-mb-8">批量备份和恢复配置</p>
                  <p class="c-fs-12 c-lh-20 c-c-text-grey">可以手动或者设置定时任务的方式，批量对指定的设备进行配置备份的工作，也可以批量进行恢复配置的工作</p>
                </div>
              </div>
            </div>
            <div class="c-mb-8 features-item">
              <div class="c-bc-white c-d-f c-pe-none">
                <img src="../../assets/monitor/config2.png">
                <div class="c-ml-24">
                  <p class="c-fs-15 c-c-text-blue c-mb-8">批量配置下发</p>
                  <p class="c-fs-12 c-lh-20 c-c-text-grey">可以通过自定义脚本的方式，对选择的批量对象，进行配置下发的工作，大大提升的运维变更的效率</p>
                </div>
              </div>
            </div>
            <div class="c-mb-8 features-item">
              <div class="c-bc-white c-d-f c-pe-none">
                <img src="../../assets/monitor/config3.png">
                <div class="c-ml-24">
                  <p class="c-fs-15 c-c-text-blue c-mb-8">定时巡检任务</p>
                  <p class="c-fs-12 c-lh-20 c-c-text-grey">针对 IT 基础环境中大批量的硬件设备而言，定期获取设备指定运行状态是一项工作量极大的工作，
                    定时巡检任务可以定义自定义的指令和定期执行获取相应数据，并输出成对应报表，大大减少了巡检的工作</p>
                </div>
              </div>
            </div>
            <div class="c-mb-8 features-item">
              <div class="c-bc-white c-d-f c-pe-none">
                <img src="../../assets/monitor/config4.png">
                <div class="c-ml-24">
                  <p class="c-fs-15 c-c-text-blue c-mb-8">设备配置对比</p>
                  <p class="c-fs-12 c-lh-20 c-c-text-grey">可以手动进行设备配置的对比，比将对比的结果差异化的展现出来，也可以定期生成配置变更报告，快速定位变更配置</p>
                </div>
              </div>
            </div>
            <div class="c-mb-32 features-item">
              <div class="c-bc-white c-d-f c-pe-none">
                <img src="../../assets/monitor/internet5.png">
                <div class="c-ml-24">
                  <p class="c-fs-15 c-c-text-blue c-mb-8">二级密码保护</p>
                  <p class="c-fs-12 c-lh-20 c-c-text-grey">使用多级密码执行，从而防止发生错误。通过控制谁能够对设备和配置进行更改，并且要求使用二级密码进行更改，提高执行的安全控制</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </section>
  </section>
</template>

<script>
export default {
  name: 'config',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
.p-configmonitor {
  @media screen and (min-width: 1180px) {
    min-height: calc(100vh - 90px - 525px);
    background: url('../../assets/monitor/monitor-bg.png') no-repeat;
    background-position: bottom;
    background-size: 100%;
  }
  .monitor-wrap {
    width: 1180px;
    margin: 0 auto;
    .monitor-title {
      img {
        height: 417px;
      }
    }
    .pic {
      position: absolute;
      right: 0;
      top: -90px;
    }
    .features {
      .features-wrap {
        .features-item {
          width: calc(50% - 7px);
          padding: 44px 54px;
          margin-bottom: 14px;
          box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.05);
          border-radius: 1px;
          img {
            width: 18%;
          }
        }
        .features-special {
          width: 100%;
          img {
            width: 10%;
          }
        }
      }
    }
  }
  .monitor-wrap-mobile {
    .monitor-title {
      img {
        // height: 202px;
        width: 100%;
      }
    }
    .features {
      .features-wrap {
        padding-bottom: 25px;
        .features-item {
          width: 100%;
          padding: 25px 16px;
          background: white;
          text-align: justify;
          img {
            width: 38px;
            height: 38px;
            object-fit: contain;
          }
        }
      }
    }
  }
}
</style>
